import { makeStyles } from '@material-ui/core';

export const useContainerStyles = makeStyles((theme) => ({
  image: {
    width: 92,
    height: 58,
    marginRight: 16,
  },
  info: {
    '& :not(:last-child)': {
      marginBottom: 5,
    },
    width: 'calc(100% - 135px)',
  },
  icon: {
    right: 0,
    position: 'absolute',
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.secondary.main,
  },
}));

export const useExchangeMobileStyles = makeStyles(() => ({
  divider: {
    '&.MuiDivider-root': {
      margin: '0px -20px',
      height: '1px',
    },
  },
}));
